import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-left font-weight-black bg-primary" }, "Dados", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-left font-weight-black bg-primary" }, "Contato", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-left font-weight-black bg-primary" }, "Endereço", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-left font-weight-black bg-primary" }, "Permissões", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(_component_v_infinite_scroll, {
    height: "100%",
    loading: "start"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        "fill-height": "",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "bg-surface px-2 py-2 h-100",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "bg-primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Dados do Usuário ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_form, {
                ref: "form",
                modelValue: _ctx.valid,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.valid) = $event)),
                "validate-on": "blur",
                onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "hidden",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usuario.id) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.usuario.id]
                  ]),
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "4",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                type: "number",
                                autofocus: "",
                                modelValue: _ctx.usuario.idSistema,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usuario.idSistema) = $event)),
                                rules: [_ctx.verificaIdSistema],
                                label: "Cód. Sistema",
                                podeAlterar: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "5",
                            md: "4",
                            class: "mr-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.login,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usuario.login) = $event)),
                                maxlength: "100",
                                counter: 100,
                                rules: [_ctx.requerid, _ctx.verificaLogin],
                                label: "Login",
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "2",
                            sm: "2",
                            class: "mr-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.usuario.ativo,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usuario.ativo) = $event)),
                                label: "Ativo?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6",
                            class: "mr-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                ref: "nome",
                                density: "compact",
                                modelValue: _ctx.usuario.nome,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.usuario.nome) = $event)),
                                maxlength: "100",
                                counter: 100,
                                rules: [_ctx.requerid],
                                label: "Razão Social \\ Nome",
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.fantasia,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.usuario.fantasia) = $event)),
                                maxlength: "100",
                                counter: 100,
                                rules: [_ctx.requerid],
                                label: "Fatansia \\ Apelido",
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4",
                            class: "mr-4"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_v_text_field, {
                                density: "compact",
                                counter: 17,
                                maxlength: "17",
                                modelValue: _ctx.usuario.cnpj,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.usuario.cnpj) = $event)),
                                rules: [_ctx.cpfcnpj, _ctx.verificaCNPJ],
                                label: "CNPJ"
                              }, null, 8, ["modelValue", "rules"]), [
                                [_directive_mask, 'CPFCNPJ']
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4",
                            class: "mr-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.iEstadual,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usuario.iEstadual) = $event)),
                                counter: 20,
                                label: "Inscrição Estadual"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "3",
                            class: "mr-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.iMunicipal,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.usuario.iMunicipal) = $event)),
                                counter: 20,
                                label: "Inscrição Municipal"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                density: "compact",
                                label: "Select",
                                items: _ctx.modulos,
                                "item-title": "descricao",
                                "item-value": "id",
                                modelValue: _ctx.usuario.modulo,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.usuario.modulo) = $event)),
                                "return-object": "",
                                "single-line": ""
                              }, null, 8, ["items", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.proprietario,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.usuario.proprietario) = $event)),
                                maxlength: "100",
                                counter: 100,
                                label: "Propietário"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.contato,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.usuario.contato) = $event)),
                                maxlength: "100",
                                counter: 100,
                                label: "Contato"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.fone,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.usuario.fone) = $event)),
                                maxlength: "11",
                                counter: 15,
                                label: "Telefone"
                              }, null, 8, ["modelValue"]), [
                                [_directive_mask, 'TEL']
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.celular,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.usuario.celular) = $event)),
                                maxlength: "12",
                                counter: 15,
                                label: "Celular"
                              }, null, 8, ["modelValue"]), [
                                [_directive_mask, 'TEL']
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                type: "email",
                                density: "compact",
                                modelValue: _ctx.usuario.email,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.usuario.email) = $event)),
                                maxlength: "100",
                                counter: 100,
                                label: "Email",
                                rules: [_ctx.requerid, _ctx.email],
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.cep,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.cep) = $event)),
                                label: "CEP",
                                counter: 9,
                                maxlength: "9",
                                onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.buscarCEP($event)))
                              }, null, 8, ["modelValue"]), [
                                [_directive_mask, 'CEP']
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "7"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.endereco,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.usuario.endereco) = $event)),
                                counter: 100,
                                label: "Endereço"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.numero,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.usuario.numero) = $event)),
                                counter: 100,
                                label: "Número",
                                maxlength: "10"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.complemento,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.usuario.complemento) = $event)),
                                counter: 100,
                                label: "Complemento"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.bairro,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.usuario.bairro) = $event)),
                                counter: 100,
                                label: "Bairro"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.cidade,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.usuario.cidade) = $event)),
                                counter: 100,
                                label: "Cidade",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.uf,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.usuario.uf) = $event)),
                                counter: 100,
                                label: "Estado",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "3",
                            sm: "4",
                            xs: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.usuario.administrador,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.usuario.administrador) = $event)),
                                label: "Administrador?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "3",
                            sm: "4",
                            xs: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.usuario.funcionario,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.usuario.funcionario) = $event)),
                                label: "funcionario?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "3",
                            sm: "4",
                            xs: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.usuario.utilizarSistema,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.usuario.utilizarSistema) = $event)),
                                label: "Utiliza Sistema?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4",
                            sm: "4",
                            xs: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.usuario.baixarXLSResvista,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.usuario.baixarXLSResvista) = $event)),
                                label: "Pode Baixar Excel Revista?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4",
                            sm: "4",
                            xs: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.usuario.baixarResvistaPDF,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.usuario.baixarResvistaPDF) = $event)),
                                label: "Pode Baixar PDF Revista?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4",
                            sm: "4",
                            xs: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.usuario.baixarXLSFabricante,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.usuario.baixarXLSFabricante) = $event)),
                                label: "Pode Baixar Excel de Fabricante?"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                density: "compact",
                                modelValue: _ctx.usuario.mensagemCadastro,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.usuario.mensagemCadastro) = $event)),
                                label: "Mensagem ao abrir sistema"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            justify: "space-between",
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "5",
                                sm: "5",
                                xs: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    size: "large",
                                    type: "submit",
                                    variant: "outlined",
                                    class: "mt-4 w-100"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Confirmar ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "5",
                                sm: "5",
                                xs: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    color: "warning",
                                    size: "large",
                                    type: "button",
                                    variant: "outlined",
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.hasHistory() ? _ctx.$router.go(-1) : _ctx.$router.push('/'))),
                                    class: "mt-4 w-100"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Cancelar ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onSubmit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}